/*
  Lara's sizes as @primeuix/themes 2 had them (PrimeNG 18-21). Themes 3, which PrimeNG 22 needs, made Lara
  more compact: 14px text, and less padding in fields, buttons, menus, tables, accordions and so on.
  This puts back every changed size in the 2.0.3 Lara preset (colours are unchanged in 3, so they are not here).
  Generated by comparing the two presets; WannabookPreset in primeng-theme.ts is applied on top of it.
*/
export const Lara2Sizes = {
  semantic: {
    typography: {
      fontSize: '1rem'
    },
    iconSize: '1rem',
    formField: {
      paddingX: '0.75rem',
      paddingY: '0.625rem',
      sm: {
        fontSize: '0.875rem',
        paddingX: '0.625rem',
        paddingY: '0.5rem'
      },
      lg: {
        fontSize: '1.125rem',
        paddingX: '0.875rem',
        paddingY: '0.75rem'
      }
    },
    list: {
      header: {
        padding: '0.625rem 1rem 0 1rem'
      },
      option: {
        padding: '0.625rem 1rem'
      },
      optionGroup: {
        padding: '0.625rem 1rem'
      }
    },
    navigation: {
      item: {
        padding: '0.625rem 1rem'
      },
      submenuLabel: {
        padding: '0.625rem 1rem'
      },
      submenuIcon: {
        size: '0.875rem'
      }
    },
    overlay: {
      popover: {
        padding: '1rem'
      },
      modal: {
        padding: '1.5rem'
      }
    }
  },
  components: {
    accordion: {
      header: {
        padding: '1.125rem'
      },
      content: {
        padding: '1.125rem'
      }
    },
    autocomplete: {
      dropdown: {
        width: '2.5rem',
        sm: {
          width: '2rem'
        },
        lg: {
          width: '3rem'
        }
      }
    },
    avatar: {
      root: {
        width: '2rem',
        height: '2rem',
        fontSize: '1rem'
      },
      icon: {
        size: '1rem'
      },
      group: {
        offset: '-0.75rem'
      },
      lg: {
        width: '3rem',
        height: '3rem',
        fontSize: '1.5rem',
        icon: {
          size: '1.5rem'
        },
        group: {
          offset: '-1rem'
        }
      },
      xl: {
        width: '4rem',
        height: '4rem',
        fontSize: '2rem',
        icon: {
          size: '2rem'
        },
        group: {
          offset: '-1.5rem'
        }
      }
    },
    badge: {
      root: {
        fontSize: '0.75rem',
        minWidth: '1.5rem',
        height: '1.5rem'
      },
      sm: {
        fontSize: '0.625rem',
        minWidth: '1.25rem',
        height: '1.25rem'
      },
      lg: {
        fontSize: '0.875rem',
        minWidth: '1.75rem',
        height: '1.75rem'
      },
      xl: {
        fontSize: '1rem',
        minWidth: '2rem',
        height: '2rem'
      }
    },
    breadcrumb: {
      root: {
        padding: '1.25rem'
      }
    },
    button: {
      root: {
        roundedBorderRadius: '2rem',
        paddingX: '1rem',
        iconOnlyWidth: '2.75rem',
        sm: {
          iconOnlyWidth: '2.25rem'
        },
        lg: {
          iconOnlyWidth: '3.25rem'
        },
        badgeSize: '1rem'
      }
    },
    datepicker: {
      header: {
        padding: '0 0 0.75rem 0'
      },
      dropdown: {
        width: '2.5rem',
        sm: {
          width: '2rem'
        },
        lg: {
          width: '3rem'
        }
      },
      selectMonth: {
        padding: '0.375rem 0.625rem'
      },
      selectYear: {
        padding: '0.375rem 0.625rem'
      },
      dayView: {
        margin: '0.75rem 0 0 0'
      },
      date: {
        width: '2.5rem',
        height: '2.5rem'
      },
      monthView: {
        margin: '0.75rem 0 0 0'
      },
      yearView: {
        margin: '0.75rem 0 0 0'
      },
      buttonbar: {
        padding: '0.75rem 0 0 0'
      },
      timePicker: {
        padding: '0.75rem 0 0 0'
      }
    },
    card: {
      body: {
        padding: '1.5rem',
        gap: '0.75rem'
      },
      title: {
        fontSize: '1.25rem'
      }
    },
    carousel: {
      indicatorList: {
        padding: '1rem'
      },
      indicator: {
        width: '1rem',
        height: '1rem'
      }
    },
    cascadeselect: {
      dropdown: {
        width: '2.5rem'
      },
      list: {
        mobileIndent: '1.25rem'
      },
      option: {
        icon: {
          size: '0.875rem'
        }
      }
    },
    checkbox: {
      root: {
        width: '1.5rem',
        height: '1.5rem',
        sm: {
          width: '1.25rem',
          height: '1.25rem'
        },
        lg: {
          width: '1.75rem',
          height: '1.75rem'
        }
      },
      icon: {
        size: '1rem',
        sm: {
          size: '0.75rem'
        },
        lg: {
          size: '1.25rem'
        }
      }
    },
    chip: {
      root: {
        paddingX: '0.875rem',
        paddingY: '0.625rem'
      },
      image: {
        width: '2rem',
        height: '2rem'
      },
      icon: {
        size: '1rem'
      },
      removeIcon: {
        size: '1rem'
      }
    },
    colorpicker: {
      preview: {
        width: '1.75rem',
        height: '1.75rem'
      }
    },
    confirmdialog: {
      icon: {
        size: '2rem'
      },
      content: {
        gap: '1rem'
      }
    },
    confirmpopup: {
      root: {
        arrowOffset: '1.25rem'
      },
      content: {
        gap: '1rem'
      },
      icon: {
        size: '1.5rem'
      }
    },
    contextmenu: {
      submenu: {
        mobileIndent: '1.25rem'
      }
    },
    datatable: {
      header: {
        padding: '0.75rem 1rem',
        lg: {
          padding: '1rem 1.25rem'
        }
      },
      headerCell: {
        padding: '0.75rem 1rem',
        lg: {
          padding: '1rem 1.25rem'
        }
      },
      bodyCell: {
        padding: '0.75rem 1rem',
        lg: {
          padding: '1rem 1.25rem'
        }
      },
      footerCell: {
        padding: '0.75rem 1rem',
        lg: {
          padding: '1rem 1.25rem'
        }
      },
      footer: {
        padding: '0.75rem 1rem',
        lg: {
          padding: '1rem 1.25rem'
        }
      },
      sortIcon: {
        size: '0.875rem'
      },
      loadingIcon: {
        size: '2rem'
      },
      rowToggleButton: {
        size: '1.75rem'
      }
    },
    dialog: {
      title: {
        fontSize: '1.25rem'
      }
    },
    dock: {
      item: {
        size: '3rem'
      }
    },
    drawer: {
      title: {
        fontSize: '1.5rem'
      }
    },
    fieldset: {
      root: {
        padding: '0.75rem 1.125rem 1.125rem 1.125rem'
      },
      legend: {
        padding: '0.625rem 0.875rem'
      }
    },
    fileupload: {
      header: {
        padding: '1.125rem'
      },
      content: {
        padding: '1.125rem'
      },
      file: {
        padding: '1rem',
        gap: '1rem'
      }
    },
    iftalabel: {
      root: {
        fontSize: '0.75rem'
      },
      input: {
        paddingTop: '1.875rem'
      }
    },
    floatlabel: {
      root: {
        active: {
          fontSize: '0.75rem'
        }
      },
      over: {
        active: {
          top: '-1.375rem'
        }
      },
      in: {
        input: {
          paddingTop: '1.875rem'
        }
      }
    },
    galleria: {
      navButton: {
        size: '3rem'
      },
      navIcon: {
        size: '1.5rem'
      },
      thumbnailsContent: {
        padding: '1rem 0.25rem'
      },
      thumbnailNavButton: {
        size: '2rem'
      },
      thumbnailNavButtonIcon: {
        size: '1rem'
      },
      caption: {
        padding: '1rem'
      },
      indicatorList: {
        padding: '1rem'
      },
      indicatorButton: {
        width: '1rem',
        height: '1rem'
      },
      closeButton: {
        size: '3rem'
      },
      closeButtonIcon: {
        size: '1.5rem'
      }
    },
    image: {
      preview: {
        icon: {
          size: '1.5rem'
        }
      },
      toolbar: {
        position: {
          right: '1rem',
          top: '1rem'
        }
      },
      action: {
        size: '3rem',
        iconSize: '1.5rem'
      }
    },
    inlinemessage: {
      icon: {
        size: '1.125rem'
      }
    },
    inputgroup: {
      addon: {
        padding: '0.625rem 0.5rem',
        minWidth: '2.75rem'
      }
    },
    megamenu: {
      root: {
        horizontalOrientation: {
          padding: '0.75rem 1rem'
        }
      },
      baseItem: {
        padding: '0.75rem 1rem'
      },
      mobileButton: {
        size: '2rem'
      }
    },
    menubar: {
      root: {
        padding: '0.75rem 1rem'
      },
      baseItem: {
        padding: '0.75rem 1rem'
      },
      submenu: {
        mobileIndent: '1.25rem'
      },
      mobileButton: {
        size: '2rem'
      }
    },
    message: {
      content: {
        padding: '0.75rem 1rem',
        sm: {
          padding: '0.5rem 0.625rem'
        },
        lg: {
          padding: '0.75rem 0.875rem'
        }
      },
      text: {
        fontSize: '1rem',
        sm: {
          fontSize: '0.875rem'
        },
        lg: {
          fontSize: '1.125rem'
        }
      },
      icon: {
        size: '1.25rem',
        sm: {
          size: '1rem'
        },
        lg: {
          size: '1.5rem'
        }
      },
      closeButton: {
        width: '2rem',
        height: '2rem'
      },
      closeIcon: {
        size: '1rem',
        sm: {
          size: '0.875rem'
        },
        lg: {
          size: '1.125rem'
        }
      }
    },
    metergroup: {
      root: {
        gap: '1rem'
      },
      meters: {
        size: '0.625rem'
      },
      labelIcon: {
        size: '1rem'
      },
      labelList: {
        horizontalGap: '1rem'
      }
    },
    multiselect: {
      dropdown: {
        width: '2.5rem'
      }
    },
    orderlist: {
      root: {
        gap: '1.125rem'
      }
    },
    organizationchart: {
      root: {
        gutter: '0.75rem'
      },
      node: {
        padding: '1rem 1.25rem',
        toggleablePadding: '1rem 1.25rem 1.5rem 1.25rem'
      },
      nodeToggleButton: {
        size: '1.75rem'
      }
    },
    popover: {
      root: {
        arrowOffset: '1.25rem'
      }
    },
    paginator: {
      root: {
        padding: '0.5rem 1rem'
      },
      navButton: {
        width: '2.5rem',
        height: '2.5rem'
      },
      jumpToPageInput: {
        maxWidth: '2.5rem'
      }
    },
    panel: {
      header: {
        padding: '1.125rem'
      },
      toggleableHeader: {
        padding: '0.25rem 1.125rem'
      },
      content: {
        padding: '1.125rem'
      },
      footer: {
        padding: '1.125rem'
      }
    },
    panelmenu: {
      submenu: {
        indent: '1rem'
      }
    },
    picklist: {
      root: {
        gap: '1.125rem'
      }
    },
    progressbar: {
      root: {
        height: '1.5rem'
      },
      label: {
        fontSize: '0.875rem'
      }
    },
    radiobutton: {
      root: {
        width: '1.5rem',
        height: '1.5rem',
        sm: {
          width: '1.25rem',
          height: '1.25rem'
        },
        lg: {
          width: '1.75rem',
          height: '1.75rem'
        }
      },
      icon: {
        size: '1rem',
        sm: {
          size: '0.75rem'
        },
        lg: {
          size: '1.25rem'
        }
      }
    },
    rating: {
      icon: {
        size: '1.25rem'
      }
    },
    select: {
      dropdown: {
        width: '2.5rem'
      }
    },
    splitbutton: {
      root: {
        roundedBorderRadius: '2rem'
      }
    },
    stepper: {
      separator: {
        margin: '0 0 0 1.625rem'
      },
      step: {
        gap: '1rem'
      },
      stepNumber: {
        size: '2.25rem',
        fontSize: '1.125rem'
      },
      steppanels: {
        padding: '0.875rem 0.5rem 1.125rem 0.5rem'
      },
      steppanel: {
        indent: '1rem'
      }
    },
    steps: {
      itemNumber: {
        size: '2.25rem',
        fontSize: '1.125rem'
      }
    },
    tabmenu: {
      item: {
        padding: '1rem 1.25rem'
      }
    },
    tabs: {
      tab: {
        padding: '1rem 1.25rem'
      },
      tabpanel: {
        padding: '0.875rem 1.125rem 1.125rem 1.125rem'
      },
      navButton: {
        width: '2.5rem'
      }
    },
    tieredmenu: {
      submenu: {
        mobileIndent: '1.25rem'
      }
    },
    tag: {
      root: {
        fontSize: '0.875rem'
      },
      icon: {
        size: '0.75rem'
      }
    },
    terminal: {
      root: {
        height: '18rem'
      }
    },
    timeline: {
      event: {
        minHeight: '5rem'
      },
      horizontal: {
        eventContent: {
          padding: '1rem 0'
        }
      },
      vertical: {
        eventContent: {
          padding: '0 1rem'
        }
      },
      eventMarker: {
        size: '1.125rem'
      }
    },
    togglebutton: {
      root: {
        padding: '0.625rem 1rem',
        sm: {
          padding: '0.5rem 0.75rem'
        },
        lg: {
          padding: '0.75rem 1.25rem'
        }
      }
    },
    toggleswitch: {
      root: {
        width: '3rem',
        height: '1.75rem'
      },
      handle: {
        size: '1.25rem'
      }
    },
    tree: {
      root: {
        padding: '1rem',
        indent: '1rem'
      },
      node: {
        padding: '0.375rem 0.625rem',
        gap: '0.25rem'
      },
      nodeToggleButton: {
        size: '1.75rem'
      },
      loadingIcon: {
        size: '2rem'
      }
    },
    treeselect: {
      dropdown: {
        width: '2.5rem'
      }
    },
    treetable: {
      header: {
        padding: '0.75rem 1rem'
      },
      headerCell: {
        padding: '0.75rem 1rem'
      },
      bodyCell: {
        padding: '0.75rem 1rem'
      },
      footerCell: {
        padding: '0.75rem 1rem'
      },
      footer: {
        padding: '0.75rem 1rem'
      },
      sortIcon: {
        size: '0.875rem'
      },
      loadingIcon: {
        size: '2rem'
      },
      nodeToggleButton: {
        size: '1.75rem'
      }
    },
    toast: {
      root: {
        width: '25rem',
        blur: '1.5px'
      },
      icon: {
        size: '1.25rem'
      },
      summary: {
        fontSize: '1rem'
      },
      detail: {
        fontSize: '0.875rem'
      },
      closeButton: {
        width: '2rem',
        height: '2rem'
      },
      closeIcon: {
        size: '1rem'
      }
    },
    toolbar: {
      root: {
        padding: '0.75rem'
      }
    },
    tooltip: {
      root: {
        maxWidth: '12.5rem',
        padding: '0.625rem 0.75rem'
      }
    }
  }
};
